import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppState } from 'src/app/app.reducer';

import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { QueueManagementStrategyOption } from '../models/queue-management-option';
import { queueManagementStrategyOptionActions } from '../state/queue-management-option.actions';
import { queueManagementStrategyOptionSelectors } from '../state/queue-management-option.reducer';

@Directive({
   selector: '[ndtQueueManagementStrategySelect]',
   standalone: false,
})
export class QueueManagementStrategySelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<QueueManagementStrategyOption>,
      private statusService: NgrxEagerSelectService<AppState, QueueManagementStrategyOption>
   ) {}

   ngAfterViewInit(): void {
      let staticFilterOverride: string[] | undefined;

      if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            queueManagementStrategyOptionActions,
            queueManagementStrategyOptionSelectors,
            () => {
               return this.additionalFields;
            },

            () => {
               return this.urlOverride;
            },

            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('queueManagementStrategyTypeId', this.trigger);
            },

            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
